import sc from 'web/components/styled';
import linkUnstyled from './linkUnstyled.css';

const AnchorUnstyled = sc.a(linkUnstyled);
AnchorUnstyled.displayName = 'AnchorUnstyled';

export default AnchorUnstyled;
